import * as THREE from 'three';

import EventDispatcher from './EventDispatcher';
import Global from './Global';

export default class Error {
  constructor() {
    document
      .querySelector('#signUpError_btn')
      .addEventListener('click', this.onSignUpError.bind(this));
    document
      .querySelector('#signInError_btn')
      .addEventListener('click', this.onSignInError.bind(this));
  }

  init() {
    this.isChecked = true;

    this.events = EventDispatcher.getObj();
    this.events.addEventListener('LOADER_EVENTS', this.onEvents.bind(this));
    this.events.addEventListener('GAME_EVENTS', this.onEvents.bind(this));
    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents.bind(this));
    // setTimeout(()=>{
    //     this.onOkay();
    // }, 1000)
  }

  onEvents(data) {
    switch (data.message.event_type) {
      case 'show_screen':
        this.showScreen(data.message.data.screenKey);
        break;
      default:
        break;
    }
  }

  showScreen(screenKey) {
    if (screenKey !== 'Error') return false;

    this.pageAnimation();
    document.querySelector('#error_scr').classList.add('active');
  }

  pageAnimation() {
    gsap.set('#error_scr .biscuit1', { x: -200, opacity: 0 });
    gsap.set('#error_scr .biscuit2', { x: 200, opacity: 0 });
    gsap.set('#signInError_btn', { opacity: 0 });
    gsap.fromTo(
      '#error_scr > .appContainer',
      { scale: 0.2, opacity: 0 },
      { scale: 1, opacity: 1, duration: 1, ease: 'power3.out' }
    );
    setTimeout(() => {
      // Animate to final position and full opacity
      gsap.to('#error_scr .biscuit1', {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: 'power3.out',
      });

      gsap.to('#error_scr .biscuit2', {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: 'power3.out',
        delay: 0.2,
      });
      this.events.dispatchEvent({
        type: 'ANIMATION_EVENTS',
        message: {
          event_type: 'buttonAnimation',
          data: {
            selector: '#signInError_btn',
          },
        },
      });
    }, 1000);
  }

  hideControls() {}

  onSignUpError() {
    Global.clickUpdater('signUpError_btn');
    document.querySelector('#error_scr').style.display = 'none';
    this.events.dispatchEvent({
      type: 'LOADER_EVENTS',
      message: {
        event_type: 'switch_page',
        data: {
          screenKey: 'SignIn',
        },
      },
    });
  }

  onSignInError() {
    Global.clickUpdater('signInError_btn');
    document.querySelector('#error_scr').style.display = 'none';
    this.events.dispatchEvent({
      type: 'LOADER_EVENTS',
      message: {
        event_type: 'switch_page',
        data: {
          screenKey: 'SignUp',
        },
      },
    });
  }

  onOkay() {
    document.querySelector('#score_sec').classList.add('active');
    document.querySelector('#error_scr').classList.remove('active');
    setTimeout(() => {
      // document.querySelector(".game_footer").classList.add("active2");
      document.querySelector('.game_timer_sec').classList.add('active');
    }, 100);
    this.events.dispatchEvent({
      type: 'GAME_EVENTS',
      message: {
        event_type: 'level_selected',
        data: {
          level: 1,
        },
      },
    });
  }
}
